<div class="basin-height-100 width-400 basin-background-true-white basin-overflow-y-auto basin-px-4 basin-py-5">
  <!-- Title -->
  <div class="study-area-name basin-display-flex basin-justify-content-space-between">
    <h5>
      {{ (selectedStudyArea$ | async)?.studyAreaName || "Study Areas" }}
    </h5>
    <div *ngIf="(selectedStudyArea$ | async)?.hasTerrain" class="symbol-landscape-2 outlined basin-color-blue"
      pTooltip="Terrain File Uploaded"></div>
  </div>

  <!-- Study Area Details -->
  <div *ngIf="selectedStudyArea$ | async; let studyArea">
    <app-study-area-details [studyArea]="studyArea"></app-study-area-details>
    <app-terrain-status></app-terrain-status>
  </div>

  <!-- Create new study area button -->
  <button *ngIf="(selectedStudyArea$ | async) === undefined" class="p-button-text basin-pt-1 basin-pb-3 basin-pt-4"
    pButton icon="symbol-add" label="Create New Study Area" (click)="openPricingTool()"
    (keydown.enter)="openPricingTool()"></button>

  <!-- Study areas dropdown -->
  <div>
    <label for="studyArea" *ngIf="(selectedStudyArea$ | async) === undefined">Study Area</label>
    <p-dropdown id="studyArea" [filter]="true" filterBy="studyAreaName,firstName,lastName" optionLabel="studyAreaName"
      styleClass="basin-width-100 created-study-area-dropdown" [options]="groupedStudyAreas$ | async"
      [(ngModel)]="selectedStudyArea" (onChange)="studyAreaChanged($event)" [placeholder]="
        (selectedStudyArea$ | async) ? 'Change Study Area' : 'Select'
      " scrollHeight="350px" [disabled]="simulationLoopService.isLooping()" [group]="true" #dropdown>
      <ng-template let-group pTemplate="group">
        <div class="basin-pl-2 basin-pt-1 basin-font-size-18 basin-font-weight-600">
          {{ group.label }}
        </div>
      </ng-template>

      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div>
          {{ selectedOption?.studyAreaName || "" }}
        </div>
      </ng-template>

      <ng-template let-studyArea pTemplate="item">
        <app-study-area-list-item [studyArea]="studyArea"
          (accessChanged)="onAccessChange($event)"></app-study-area-list-item>
      </ng-template>
    </p-dropdown>
  </div>

  <!-- Accordian sections -->
  <p-accordion expandIcon="symbol-expand-more" collapseIcon="symbol-expand-less" [multiple]="true">
    <p-divider *ngIf="selectedStudyArea$ | async"></p-divider>

    <p-accordionTab header="Add Files" [disabled]="(selectedStudyArea$ | async) === undefined"
      *ngIf="selectedStudyArea$ | async">
      <app-add-files-section></app-add-files-section>
    </p-accordionTab>

    <p-divider *ngIf="selectedStudyArea$ | async"></p-divider>

    <p-accordionTab header="Agent Settings" *ngIf="selectedStudyArea$ | async" [disabled]="
        (terrainLoaded$ | async) === false ||
        (selectedStudyArea$ | async) === undefined
      ">
      <app-agent-settings-section></app-agent-settings-section>
    </p-accordionTab>

    <p-divider *ngIf="selectedStudyArea$ | async"></p-divider>

    <p-accordionTab header="Export" *ngIf="selectedStudyArea$ | async; let studyArea" [disabled]="
        (terrainLoaded$ | async) === false ||
        (selectedStudyArea$ | async) === undefined
      ">
      <app-export-section></app-export-section>
    </p-accordionTab>
  </p-accordion>
</div>